export default "__VITE_ASSET__B5ZZQR48__"